<template>
    <v-tooltip content-class="elevation-1" v-bind="$attrs" :right="right">
        <template v-slot:activator="{ on }">
            <span :class="['d-flex align-center cursor', reverseOrderClass]" v-on="on">
                <v-icon :class="[iconClasses, 'ml-2']" v-bind="iconAttrs">{{ icon }}</v-icon>
                <span class="ml-1" :class="[textColor, labelSize]">{{ labelText }}</span>
            </span>
        </template>
        <div :style="[contentStyle]">
            <span v-html="content"></span>
        </div>
    </v-tooltip>
</template>
<script>
  export default {
    name: 'ToolTip',
    props: {
      content: { type: String },
      icon: { type: String },
      iconAttrs: { type: Object, required: false },
      contentStyle: { type: [String, Object], required: false },
      iconClasses: { type: String, required: false },
      labelText: { type: String, required: false },
      textColor: { type: String, required: false }, // Nova prop para a cor do texto
      reverseOrderClass: { type: String, required: false },
      right: { type: Boolean, default: false },
      labelSize: { typeof: String, required: false }
    }
  }
</script>

<style lang="css" scoped>
.label-size {
  font-size: 1.5rem
}

.vertical-align-text {
  vertical-align: middle; /* Alinha verticalmente o texto ao meio do ícone */
}

.cursor{
    cursor: default;
}

.reverse-order {
    flex-direction: row-reverse;
}

</style>
